import * as Yup from "yup";

export const useSensorConfig = (t) => ({
    initialSensorValues: {
        sCustomer: "",
        sFirstname: "",
        sLastname: "",
        sCompany: "",
        department: "",
        street: "",
        number: "",
        sCity: "",
        zip: "",
        sCountry: "",
        sPhone: "",
        sEmail: "",
        sGdpr: ""
    },
    sensorSchema: {
        sCustomer: Yup.string(),
        sFirstname: Yup.string().required(
            t("form.registration.firstname.error")
        ),
        sLastname: Yup.string().required(
            t("form.registration.lastname.error")
        ),
        sCompany: Yup.string().required(
            t("form.registration.company.error")
        ),
        department: Yup.string(),
        street: Yup.string().required(
            t("form.registration.street.error")
        ),
        number: Yup.string().required(
            t("form.registration.number.error")
        ),
        sCity: Yup.string().required(
            t("form.registration.city.error")
        ),
        zip: Yup.string().required(
            t("form.registration.zipcode.error")
        ),
        sCountry: Yup.string(),
        sPhone: Yup.number().required(
            t("form.registration.phone.error")
        ),
        sEmail: Yup.string()
            .email()
            .required(t("form.registration.email.error")
        ),
        sGdpr: Yup.boolean()
            .oneOf(
                [true],
                t("form.registration.privacypolicy.error")
            )
            .required(t("form.registration.privacypolicy.error")
        )
    }
})